import { Enum } from 'enumify';

class UploadType extends Enum {}

UploadType.initEnum(['TRACK', 'RENDERED', 'WIZARD']);

export default UploadType;
